import api from 'data/api';

export const loadSummary = api('POST /api/mobile/dashboard/summary');
